import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar'
import { DoubleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import Footer from '../../components/Footer'
import { useTranslation } from 'react-i18next'
import icon_arrow_right from "../../assets/images/icons/arrow_24px_right.svg"
import icon_qr_code from "../../assets/images/icons/qr_code_80px.svg"
import icon_money_inscreases from "../../assets/images/icons/money_increases_80px.svg"
import icon_shield_checked from "../../assets/images/icons/shield_check_80px.svg"
import icon_golf_goal from "../../assets/images/icons/golf_goal_80px.svg"
import icon_heart_broken from "../../assets/images/icons/heart_broken_80px.svg"
import icon_education from "../../assets/images/icons/education_80px.svg"
import { selectLanguage } from '../../redux/language/selector'
import { useSelector } from 'react-redux'
import filter_color from "../../assets/images/design/colorFilter.svg"
import { StyledLink } from '../../components/StyledComponents'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'

const Industries = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    useEffect(() => {
        document.title = t('web-title.industries')
        // eslint-disable-next-line
    }, [language])

    return (
        <div className='industries bg-primary'>
            <div className='color-filter-right' style={{ top: "35%" }}>
                <img src={filter_color} alt="" />
            </div>
            <div className='color-filter-left' style={{ top: "55%" }}>
                <img src={filter_color} alt="" />
            </div>
            <Navbar />
            <div className='container-fluid industries-header pb-100'>
                <div className='container'>
                    <div className='col-sm-12 pt-200'>
                        <p className='font-weight-bold text-center font-96 industries-header-title'>{t('industries.header')}</p>
                    </div>
                    <div className='col-sm-12 flex justify-center pt-150'>
                        <DoubleCustomBreadCrumbs currentPage={t('bread-crumbs.industries')} />
                    </div>
                </div>
            </div>
            <div className='industries-content container'>
                {language === "en" ?
                    <div className='text-center col-sm-10 col-sm-offset-1'>
                        <p className='font-42 font-weight-semi-bold text-white'><span className='text-primary-orange'>Industries </span>benefiting from Qrypto</p>
                        <p className='text-gray pt-20'>QR Codes for Industries: Qrypto’s aim is to enable information sharing through documents with full trust, security and privacy in the most user friendly manner with high efficiency to save on costs and time.</p>
                    </div>
                    :
                    <div className='text-center col-sm-12'>
                        <p className='font-42 font-weight-semi-bold text-white'><span className='text-primary-orange'>Lợi ích </span>của Qrypto dành cho các ngành công nghiệp</p>
                        <p className='text-gray pt-20'>Mã QR dành cho các ngành: Mục tiêu của Qrypto là cho phép chia sẻ thông tin qua các tài liệu với sự tin cậy, bảo mật và quyền riêng tư hoàn toàn theo cách thân thiện với người dùng nhất với hiệu quả cao để tiết kiệm chi phí và thời gian.</p>
                    </div>
                }
                <div className='industries-card col-sm-12 px-0'>
                    <div className='row'>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/industries/general-and-hr">
                                <div className='industries-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{t('home-page.industries.general')}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_qr_code} alt="qr_code" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{t('home-page.industries.general-content')}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/industries/banking-and-financial">
                                <div className='industries-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{t('home-page.industries.banking-financial')}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_money_inscreases} alt="money_inscreases" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{t('home-page.industries.banking-financial-content')}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/industries/insurance">
                                <div className='industries-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{(t('home-page.industries.insurance'))}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_shield_checked} alt="shield_checked" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{(t('home-page.industries.insurance-content'))}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/industries/government">
                                <div className='industries-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{(t('home-page.industries.govt-regulators'))}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_golf_goal} alt="golf_goal" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{(t('home-page.industries.govt-regulators-content'))}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/industries/healthcare">
                                <div className='industries-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{t('home-page.industries.healthcare')}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_heart_broken} alt="heart_broken" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{t('home-page.industries.healthcare-content')}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                        <div className='col-md-12 col-lg-6 pt-50 '>
                            <StyledLink href="/industries/education">
                                <div className='industries-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{t('home-page.industries.education')}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_education} alt="education" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{t('home-page.industries.education-content')}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                    </div>
                </div>

            </div>
            <div className='container'>
                <IndustriesImageContainer />
            </div>
            <Footer />
        </div>
    )
}

export default Industries